// src/ComingSoonPage.js
import React from 'react';
import { Link } from 'react-router-dom'; // For a "Go Back" link
import './Doc.css'; // We'll create this CSS file

const SubmitPage = () => {
  return (
    <div className="doc-container">
      <h1>This Page is Coming Soon!</h1>
      <p>We are working hard to bring you this feature. Please check back later.</p>
      <Link to="/" className="back-button">Go Back to Home</Link> {/* Assuming '/' is your leaderboard page */}
    </div>
  );
};

export default SubmitPage;